import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import {
    SnowplowService,
    clearGtmUserData,
    gtm,
} from 'wanderu-service-analytics';

import { actions } from './base';
import { actions as userInfoActions } from '../../appstate/userInfo';

const logger = Logger.getLogger('wanderu-ducks-account');

function logOut() {
    return async (dispatch) => {
        dispatch(actions.startWork());

        let meta;
        let error;
        try {
            await AccountService.logOut();

            // Dispatch first: the session is already dead server-side, and the
            // analytics retraction below is strictly less important than the
            // state change. A throwing push still reaches the catch and is
            // logged, but the user is logged out in Redux either way.
            const loggedOut = dispatch(userInfoActions.setLoggedOut());

            // The GTM tags read the accumulated data model, not the push, so
            // without this the hashed match signal and user_id from the account
            // that just signed out ride along on every event the next visitor
            // on this device generates.
            clearGtmUserData();
            gtm.dataLayer.push({ user_id: undefined });

            return loggedOut;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('logOut', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }

        return null;
    };
}

export {
    logOut,
};
